import { render, staticRenderFns } from "./ObjectType.vue?vue&type=template&id=2fa41f05&"
import script from "./ObjectType.vue?vue&type=script&lang=ts&"
export * from "./ObjectType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports